export const WECHAT_APPID = 'wxf76bf386d0fdcc0e';
export const WX_MINI_PROGRAM_ID = 'gh_b82afba91e32';

export const DRIVER_WX_MINI_CLITENT_TYPE = 'xl_driver_wxa';

// 准入全流程语音播报最低可用版本（https://kfft6vo8un.feishu.cn/wiki/YFbPwb42wiW4xkk4umEcjYBnn7b）
export const GLOBAL_VOICE_MIN_VERSION = 1516;

export const WEIXIN_JSDK_URL = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
